import { AddressService } from '@common/lib/api';
import * as address from './types';

const actions = {
  // 인터넷 커머스 신청 - 사용자
  async [address.SEARCH_ADDRESS_LIST](context, params) {
    console.log('SEARCH_ADDRESS_LIST');
    console.log(params);

    const { data } = await AddressService.search(params);
    console.log(data);

    context.commit(address.SET_ADDRESS_LIST, data);

    return data;
  },
};

export default actions;
